<div class="overlay">
    <p>{{ email }}</p>
    <p *ngIf="!isAdmin">{{ customerName }}</p>
    <p *ngIf="!isSuperAdmin && isAdmin">{{ 'General.Admin' | translate }}</p>
    <p *ngIf="isSuperAdmin">{{ 'General.SuperAdmin' | translate }}</p>
    <button mat-flat-button (click)="logout()">{{ 'Initials-Overlay.logout' | translate }}</button>
</div>